import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters.roles
    const permissionRoles = value
    // console.log('roles', roles.some(role => ['file:pay', 'project:pay'].includes(role)))
    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })
    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like v-permission="['editor']"`)
    return false
  }
}

// export default function checkPermission(value = []) {
//   if (!(value && value instanceof Array)) {
//     console.error(`need roles! Like v-permission="['editor']"`)
//     return false
//   }
//   if (value.length > 0) {
//     const permission = store.getters && store.getters.permission
//     for (let item of value) {
//       if (permission[item]) {
//         return true
//       }
//     }
//     return false
//   } else {
//     return true
//   }
// }
